import React, { useState } from 'react';
import styled from 'styled-components';

const DevLogin = ({ onClose }) => {
  const [username, setUsername] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!username.trim()) return;
    
    window.location = `/api/login/dev?username=${encodeURIComponent(username)}`;
  };

  return (
    <Overlay onClick={onClose}>
      <Container onClick={(e) => e.stopPropagation()}>
        <Title>Development Login</Title>
        <Form onSubmit={handleSubmit}>
          <Label>
            Username
            <Input 
              type="text" 
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter username"
              autoFocus
            />
          </Label>
          <HelpText>
            Using 'admin' as username will create an admin user
          </HelpText>
          <ButtonContainer>
            <Button type="submit" disabled={!username.trim()}>
              Login
            </Button>
            <Button type="button" secondary onClick={onClose}>
              Cancel
            </Button>
          </ButtonContainer>
        </Form>
      </Container>
    </Overlay>
  );
};

export default DevLogin;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const Container = styled.div`
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

const Title = styled.h2`
  margin-top: 0;
  color: var(--color-splash-purple);
  font-size: 1.5rem;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const Label = styled.label`
  display: flex;
  flex-direction: column;
  gap: 5px;
  font-weight: bold;
`;

const Input = styled.input`
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 1rem;
`;

const HelpText = styled.p`
  font-size: 0.8rem;
  color: #666;
  margin: 0;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
`;

const Button = styled.button`
  background-color: ${props => props.secondary ? '#ccc' : 'var(--color-splash-purple)'};
  color: white;
  border: none;
  border-radius: 5px;
  padding: 10px 15px;
  font-weight: bold;
  cursor: pointer;
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  
  &:hover:not(:disabled) {
    opacity: 0.9;
  }
`;